import React, { useState } from "react";
import API from "../../ApiService/ApiService";
import Context from "./index";
// clinic provider

const ClinicProvider = (props) => {
  const api = new API();
  const [clinicData, setClinicData] = useState("");
  const [ClinicLoader, setClinicLoader] = useState(false);

  const [selectedClinicData, setSelectedClinicData] = useState({
    clinicId: "",
    doctorId: "",
    doctorName: "",
  });

  const getClinicData = async (slug) => {
    // Assuming your `getSingle` method expects one argument for the complete URL
    // const clinicSlug = slug; // Clinic slug

    // Construct the full URL dynamically
    const url = `clinic/clinic_search?clinic_slug=`;
    setClinicLoader(true);
    // Call the API with the constructed URL
    await api.getAll(url, { clinic_slug: slug }, (err, res) => {
      if (res?.data?.status === 200) {
        console.log("Fetched Data:", res?.data?.data);
        const data = res?.data?.data;
        setClinicData(data.data); // Store data in state
      } else {
        console.error("Error fetching data:", err);
      }
      setClinicLoader(false);
    });
  };

  return (
    <Context.Provider
      value={{
        clinicData,
        getClinicData,
        ClinicLoader,
        selectedClinicData,
        setSelectedClinicData,
        ...props,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default ClinicProvider;
